import {useState} from "react";
import {Send} from "lucide-react";
import {FormModal} from "@/components/UI";
import {apiPost} from "@/lib/api";
import {LIFESTYLE_TOPICS, COMMUNITY_COLORS} from "@/lib/constants";

export default function CreateCircleModal({close, notify}) {
  const [f, setF] = useState({name: "", description: "", type: "Public", topic: "Festivals", color: "coral"});
  const ch = e => setF({...f, [e.target.name]: e.target.value});
  const submit = async (e) => {
    e.preventDefault();
    try {
      await apiPost("/communities", f);
      notify("Samaj sent for admin approval");
      close();
    } catch { notify("Sign in to create a samaj"); }
  };
  return (
    <FormModal title="Start a samaj." eyebrow="CREATE SAMAJ" close={close} testId="create-circle">
      <p className="modal-sub">Admin reviews every new samaj before it goes live.</p>
      <form onSubmit={submit}>
        <label>Samaj name
          <input data-testid="circle-name" required minLength={3} name="name" value={f.name} onChange={ch} placeholder="e.g. Houston Gujarati Moms"/>
        </label>
        <label>Lifestyle subject
          <select data-testid="circle-topic" name="topic" value={f.topic} onChange={ch}>
            {LIFESTYLE_TOPICS.map(t => <option key={t}>{t}</option>)}
          </select>
        </label>
        <label>Who can join?
          <select data-testid="circle-type" name="type" value={f.type} onChange={ch}>
            <option value="Public">Public — anyone can join and read</option>
            <option value="Private">Private — visible to everyone, you approve who joins</option>
          </select>
        </label>
        <label>Accent colour
          <select data-testid="circle-color" name="color" value={f.color} onChange={ch}>
            {COMMUNITY_COLORS.map(c => <option key={c}>{c}</option>)}
          </select>
        </label>
        <label>Describe your samaj
          <textarea data-testid="circle-description" name="description" value={f.description} onChange={ch} placeholder="What's this samaj about?"/>
        </label>
        <button data-testid="circle-submit" className="coral-button full" type="submit">Send for approval <Send size={14}/></button>
      </form>
    </FormModal>
  );
}
